<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 认证IP黑名单检查策略 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.mode_switch16") }}</span>
                <div class="main  maina-a">
                    <p>
                        <span class="main_text"> {{ $t("logs.mode_switch14") }}:</span>
                        <el-select v-model="permit_login" placeholder="请选择">
                            <el-option v-for="item in permit_login_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button @click="save_defaut()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>
                        <el-button @click="tan_ip()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.ldap14") }}</el-button>
                        <el-alert :title="this.show_hint1" type="warning" show-icon :closable="false"></el-alert>
                    </p>

                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="USERNAME" :label="$t('logs.autu5_a2')"> </el-table-column>
                            <el-table-column prop="SHOW_MANAGER" :label="$t('logs.mode_switch17')"> </el-table-column>
                               <el-table-column prop="SHOW_LOGIN" :label="$t('logs.mode_switch18')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ip(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑 -->
                                    <el-button @click="edit_ip(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.ldap14_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.autu5_a2") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="username" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 用户类型 -->

                                    {{ $t("logs.mode_switch17") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                             <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 登录类型 -->

                                    {{ $t("logs.mode_switch18") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="permit_login_type" placeholder="请选择">
                                        <el-option v-for="item in permit_login_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_edit" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.notify11')}}</div>
                        <p></p>
                        
 <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.autu5_a2") }}:
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.username}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 用户类型 -->

                                    {{ $t("logs.mode_switch17") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                             <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 登录类型 -->

                                    {{ $t("logs.mode_switch18") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="permit_login_type" placeholder="请选择">
                                        <el-option v-for="item in permit_login_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-row>
                            <el-button type="primary" @click="save_edit_ip()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_edit_ip()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            show_hint1: '',
            tanchu_edit: false,
            permit_login_arr: [],
            permit_login_type_arr: [],

            permit_login: '',
            permit_login_type:2,
            type:2,
            type_arr: [],
            username: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            email: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList1: [],
            radio: [],
        };
    },
    mounted() {
        this.getFileList1()

    },
    methods: {
        save_edit_ip() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_gate_user_priv",
                sid: sid,
                is_manager: this.type,
                permit_login: this.permit_login_type,
                username: this.username,

            });
            this.$axios
                .post("/api/adm/cgi/admin.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        del_ip(index, row) {
            console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_gate_user_priv",
                        sid: sid,

                        id: row.ID,
                        

                    });
                    this.$axios
                        .post("/api/adm/cgi/admin.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList1()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_ip() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_gate_user_priv",
                sid: sid,

                is_manager: this.type,
                permit_login: this.permit_login_type,
                username: this.username,
                newadd: 1

            });
            this.$axios
                .post("/api/adm/cgi/admin.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        edit_ip(index, row) {
            console.log(index, row)
            // this.email = row.EMAIL
            // this.type = row.VALUE
            
            this.permit_login_type = row.PERMIT_LOGIN
            this.username = row.USERNAME
            this.type = row.IS_MANAGER
            this.tanchu_edit = true

        },
        off_edit_ip() {
            this.tanchu_edit = false
        },
        tan_ip() {
            this.tanchu = true
            this.username = ''
        },
        off_ip() {
            this.tanchu = false

        },
        save_defaut() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/admin.cgi", {
                    params: {
                        __mode: "save_gate_user_dft_login",
                        sid: sid,
                        permit_login: this.permit_login,
                        
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/admin.cgi", {
                    params: {
                        __mode: "show_gateuserpriv",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                   
                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList1 = res.data.ret.datalist
                        this.permit_login_arr = res.data.ret.q_type
                        // this.permit_login_type_arr = res.data.ret.q_type
                        this.type_arr = res.data.ret.q_user_type
                        this.permit_login = res.data.ret.DFT_GATE_USER_LOGIN
                        this.show_hint1 = res.data.ret.LOAD_HINT

                    }
                })
                
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
// 1
.main {
    display: flex;
    align-items: center;
    border: 2px solid #D2D7E6;

    // background: #f1f1f1;
    margin: 10px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
}

.main_text {
    margin-right: 6px;

    color: #0E2C5E;
}

.main .el-input {
    margin-right: 6px
}

.main .el-select {
    margin-right: 6px
}

.main span {}

.main {
    padding: 0;
}

/deep/ .el-input__icon {
    height: 24px;
    line-height: 24px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-tabs__nav {
    padding-left: 14px;
}
</style>
